import { Tooltip } from "element-ui";

 export const costManagementTable = [
    {
        prop:'companyIdStr',
        label:'所属公司'
    },
    {
        prop:'brandIdStr',
        label:'所属品牌'
    },
    {
        prop:'modelIdStr',
        label:'车型'
    },
    {
        prop:'provinceName',
        label:'省份'
    },
    {
        prop:'cityName',
        label:'市'
    },
    {
        prop:'areaName',
        label:'区/县'
    },
    {
        prop:'installationFee',
        label:'安装费用'
    },
    {
        prop:'remarks',
        label:'备注',
    },
    {
        prop:'createTime',
        label:'创建时间',
        width: 150
    },
    {
        prop:'createdByStr',
        label:'创建人'
    },
    {
        prop:'updateTime',
        label:'修改时间',
        width: 150
    },
    {
        prop:'updatedByStr',
        label:'修改人'
    },
]
